import { render, staticRenderFns } from "./Gallery4.vue?vue&type=template&id=b8dbbb3a&scoped=true"
import script from "./Gallery4.vue?vue&type=script&lang=ts"
export * from "./Gallery4.vue?vue&type=script&lang=ts"
import style0 from "./Gallery4.vue?vue&type=style&index=0&id=b8dbbb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dbbb3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
